import { makeStyles } from 'tss-react/mui';

export const usePublicChainsCheckboxStyles = makeStyles({
  name: 'PublicChainsCheckbox',
})(theme => ({
  mobileMenuButton: {
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.background.paper,
  },
  mobileMenuIcon: {
    color: theme.palette.text.secondary,
  },
  publicCheckboxLabel: {
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
  },
}));
